import { render, staticRenderFns } from "./title-bar.vue?vue&type=template&id=a78cae0c&scoped=true"
import script from "./title-bar.vue?vue&type=script&lang=js"
export * from "./title-bar.vue?vue&type=script&lang=js"
import style0 from "./title-bar.vue?vue&type=style&index=0&id=a78cae0c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a78cae0c",
  null
  
)

export default component.exports